import React, { Component } from 'react';
import ReactApexChart from "react-apexcharts";

class OperatorStatusCount extends Component {

    generateHourInt = (startPeriod, count) => {
        const periods = [];
        const startHour = parseInt(startPeriod.split(':')[0], 10); // e.g., 9 from '09:00-10:00'

        for (let i = 0; i < count; i++) {
            const fromHour = startHour + i;
            const toHour = fromHour + 1;

            const format = h => h.toString().padStart(2, '0') + ":00";
            periods.push(`${format(fromHour)}-${format(toHour)}`);
        }

        return periods;
    }

    constructor(props) {
        super(props);

        const dynamicHourInt = this.generateHourInt(this.props.hourInt[0], this.props.ticketCount.length);

        this.state = {
            h: ((this.props.ticketCount.length * 50) + 100) + "px",

            options: {
                chart: {
                    type: 'bar',
                    stacked: true,
                    toolbar: { show: false }
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        borderRadius: 7,
                        barHeight: '70%'
                    }
                },
                xaxis: {
                    title: { text: 'Ticket Count' },
                    min: 0
                },
                yaxis: {
                    categories: dynamicHourInt,
                    title: { text: 'Time' }
                },
                colors: ['#4D4DFF'],
                grid: { show: false },
                legend: { show: false }
            },
            series: [{
                name: "Served Tokens",
                data: this.props.ticketCount
            }]
        };
    }

    componentDidUpdate(prevProps, prevState) {
        const dynamicHourInt = this.generateHourInt(this.props.hourInt[0], this.props.ticketCount.length);

        if (prevProps.chartValue !== this.props.chartValue ||
            prevProps.hourInt !== this.props.hourInt ||
            prevProps.ticketCount !== this.props.ticketCount) {
            this.setState({
                h: ((this.props.ticketCount.length * 50) + 100) + "px",
                options: {
                    chart: {
                        type: 'bar',
                        stacked: true,
                        toolbar: { show: false }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                            borderRadius: 7,
                            barHeight: '70%'
                        }
                    },
                    xaxis: {
                        title: { text: 'Ticket Count' },
                        min: 0
                    },
                    yaxis: {
                        categories: dynamicHourInt  ,
                        title: { text: 'Time' }
                    },
                    colors: ['#4D4DFF'],
                    grid: { show: false },
                    legend: { show: false }
                },
                series: [{
                    name: "Served Tokens",
                    data: this.props.ticketCount
                }]
            });
        }
    }

    render() {
        return (
            <div>
                {this.props.hourInt.length > 0 && this.props.ticketCount.length > 0 ? (
                    <ReactApexChart
                        options={this.state.options}
                        series={this.state.series}
                        type="bar"
                        height={this.state.h}
                        width="600px"
                    />
                ) : (
                    <div>Loading chart...</div>
                )}
            </div>
        );
    }
}

export default OperatorStatusCount;
